import { customerAxios } from "./config/createAxiosInstance";

export const customerAPI = {
  getSalesOrgs: async function () {
    const response = await customerAxios.request({
      url: `/customers/salesOrgs`,
      method: "GET",
    });
    return response.data;
  },

  getCustomers: async function (salesOrg) {
    const response = await customerAxios.request({
      url: `/customers`,
      method: "GET",
      params: {
        salesOrg
      }
    });
    return response.data;
  },
};
